<template>
  <div id="app">
    <img src="static/logo_jg.png">
    <hello></hello>
  </div>
</template>

<script type="text/ecmascript-6">
  /*eslint-disable*/
  import Hello from 'components/Hello'
  window.onload = function(){
    window.location.href = window.location.href + 'home.html'
  }
  export default {
    name: 'app',
    components: {
      Hello
    }
  }

  
  
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// App.vue?23fad5f0